import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    redirect: '/check',
    
    children: [
      //checkAble
      {
        path: '/check',
        name: 'check',
        component: () => import(/* webpackChunkName: "check" */ '../views/check/Check.vue')
      },
      // 리마인더
      {
        path: '/reminder',
        name: 'reminder',
        component: () => import(/* webpackChunkName: "reminder" */ '../views/reminder/Reminder.vue')
      },

      // 회원
      {
        path: '/user',
        name: 'user',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/UserList.vue')
      },
      {
        path: '/user/dormant',
        name: '/user/dormant',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/DormantUserList.vue')
      },
      {
        path: '/user/:idx',
        name: 'user-detail',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/UserDetail.vue')
      },
      {
        path: '/user-edit/:idx',
        name: 'user-edit',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/UserEdit.vue')
      },
      {
        path: '/user-add',
        name: 'user-add',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/UserAdd.vue')
      },
      {
        path: '/user-alert',
        name: 'user-alert',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/UserAlert.vue')
      },
      {
        path: '/user-alert/:idx',
        name: 'user-alert-detail',
        component: () => import(/* webpackChunkName: "user" */ '../views/user/UserAlertDetail.vue')
      },
      
      // 알림
      {
        path: '/alert',
        name: 'alert',
        component: () => import(/* webpackChunkName: "alert" */ '../views/alert/Alert.vue')
      },
      {
        path: '/alert/operate',
        name: 'operate',
        component: () => import(/* webpackChunkName: "alert" */ '../views/alert/Operate.vue')
      },

      // 결제
      {
        path: '/payment',
        name: 'payment',
        component: () => import(/* webpackChunkName: "payment" */ '../views/payment/Charge.vue')
      },
      {
        path: '/payment/:idx',
        name: 'payment-detail',
        component: () => import(/* webpackChunkName: "payment" */ '../views/payment/ChargeDetail.vue')
      },
      {
        path: '/payment-used',
        name: 'payment-used',
        component: () => import(/* webpackChunkName: "payment" */ '../views/payment/Usage.vue')
      },
      {
        path: '/payment-used/:idx',
        name: 'payment-used-detail',
        component: () => import(/* webpackChunkName: "payment" */ '../views/payment/UsageDetail.vue')
      },
      {
        path: '/payment-cancel',
        name: 'payment-cancel',
        component: () => import(/* webpackChunkName: "payment" */ '../views/payment/Cancel.vue')
      },
      {
        path: '/payment-manage',
        name: 'payment-manage',
        component: () => import(/* webpackChunkName: "payment" */ '../views/payment/Manage.vue')
      },

      // 문의
      {
        path: '/inquiry/member',
        name: 'inquiry-member',
        component: () => import(/* webpackChunkName: "about" */ '../views/inquiry/Member.vue')
      },
      {
        path: '/inquiry/non-member',
        name: 'inquiry-non-member',
        component: () => import(/* webpackChunkName: "about" */ '../views/inquiry/NonMember.vue')
      },





      // 교육
      {
        path: '/education/program-management',
        name: 'education-program-management',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/ProgramManagement.vue')
      },
      {
        path: '/education/program-education/:code',
        name: 'education-program-home',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/ProgramEducation.vue')
      },
      {
        path: '/education/program-add',
        name: 'education-program-add',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/AddProgram.vue')
      },
      {
        path: '/education/program-detail/:code',
        name: 'education-program-detail',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/ProgramDetail.vue')
      },
      {
        path: '/education/program-edit/:code',
        name: 'education-program-edit',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/EditProgram.vue')
      },
      {
        path: '/education/applicant',
        name: 'education-applicant',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/Applicant.vue')
      },
      {
        path: '/education/completion',
        name: 'education-completion',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/Completion.vue')
      },
      {
        path: '/education/survey',
        name: 'education-survey',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/SurveyAlert.vue')
      },
      {
        path: '/education/user/:idx',
        name: 'education-user-detail',
        component: () => import(/* webpackChunkName: "education" */ '../views/education/UserDetail.vue')
      },
      
      
      // 통계
      {
        path: '/statistics/user',
        name: 'statistics-user',
        component: () => import(/* webpackChunkName: "statistics" */ '../views/statistics/User.vue')
      },
      {
        path: '/statistics/data',
        name: 'statistics-data',
        component: () => import(/* webpackChunkName: "statistics" */ '../views/statistics/Data.vue')
      },
      {
        path: '/statistics/project',
        name: 'statistics-project',
        component: () => import(/* webpackChunkName: "statistics" */ '../views/statistics/Project.vue')
      },


      // 진단도구
      {
        path: '/tool/survey/:id',
        name: 'tool-survey',
        component: () => import(/* webpackChunkName: "tool" */ '../views/tool/Home.vue')
      },
      {
        path: '/tool/report-contents/:id',
        name: 'tool-report-contents',
        component: () => import(/* webpackChunkName: "tool" */ '../views/tool/Home.vue')
      },
      {
        path: '/tool/grading-logic/:id',
        name: 'tool-grading-logic',
        component: () => import(/* webpackChunkName: "tool" */ '../views/tool/Home.vue')
      },
      {
        path: '/tool/api/:id',
        name: 'tool-api',
        component: () => import(/* webpackChunkName: "tool" */ '../views/tool/Home.vue')
      },


      
      // 팀원
      {
        path: '/team/member',
        name: 'team-member',
        component: () => import(/* webpackChunkName: "team" */ '../views/team/Member.vue')
      },

      // 세팅
      {
        path: '/setting',
        name: 'setting',
        redirect: '/setting/chg-pw'
      },
      {
        path: '/setting/chg-pw',
        name: 'setting-chg-pw',
        component: () => import(/* webpackChunkName: "setting" */ '../views/setting/ChgPw.vue')
      },
      {
        path: '/setting/push',
        name: 'setting-push',
        component: () => import(/* webpackChunkName: "setting" */ '../views/setting/Push.vue')
      },
      {
        path: '/setting/report-type',
        name: 'setting-report-type',
        component: () => import(/* webpackChunkName: "setting" */ '../views/setting/ReportType.vue')
      },
      {
        path: '/setting/program-type',
        name: 'setting-program-type',
        component: () => import(/* webpackChunkName: "setting" */ '../views/setting/ProgramType.vue')
      },

      // 홈페이지
      {
        path: '/homepage',
        name: 'homepage',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/Homepage.vue')
      },
      {
        path: '/homepage/test-guide-img',
        name: 'homepage-test-guide-img',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/TestGuideImg.vue')
      },
      {
        path: '/homepage/notice-news',
        name: 'homepage-notice-news',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/NoticeNews.vue')
      },
      {
        path: '/homepage/notice-news/create',
        name: 'homepage-notice-news-create',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/NoticeNewsCreate.vue')
      },
      {
        path: '/homepage/faq',
        name: 'homepage-faq',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/Faq.vue')
      },
      {
        path: '/homepage/faq/create',
        name: 'homepage-faq-create',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/FaqCreate.vue')
      },
      {
        path: '/homepage/hive',
        name: 'homepage-hive',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/Hive.vue')
      },
      {
        path: '/homepage/hive/create',
        name: 'homepage-hive-create',
        component: () => import(/* webpackChunkName: "homepage" */ '../views/homepage/HiveCreate.vue')
      },

    ]
  },
  {
    path:'/login',
    name:'login',
    component: ()=> import('../views/Login.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 };
  },
})


export default router
